import { useState, useEffect } from "react";
import { Autocomplete, TextField, Grid, Typography } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";

// eslint-disable-next-line no-undef
const GOOGLE_MAPS_API_KEY = "AIzaSyCBWVlKOQi_AeWammcvZ2u_ba3mTCEp6t0";

function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = resolve;
    document.head.appendChild(script);
  });
}

export default function GoogleSearchBox({ label, onPlaceSelected }) {
  const [autocompleteService, setAutocompleteService] = useState(null);
  const [placesService, setPlacesService] = useState(null);
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [value, setValue] = useState(null);

  useEffect(() => {
    if (!window.google) {
      loadScript(
        `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`
      ).then(() => {
        setAutocompleteService(new window.google.maps.places.AutocompleteService());
        setPlacesService(new window.google.maps.places.PlacesService(document.createElement("div")));
      });
    } else {
      setAutocompleteService(new window.google.maps.places.AutocompleteService());
      setPlacesService(new window.google.maps.places.PlacesService(document.createElement("div")));
    }
  }, []);

  useEffect(() => {
    if (!inputValue || !autocompleteService) return;

    const request = { input: inputValue, types: ["address"] };
    autocompleteService.getPlacePredictions(request, (predictions) => {
      setOptions(predictions || []);
    });
  }, [inputValue, autocompleteService]);

  const handleSelect = (selected) => {
    setValue(selected);
    if (selected && placesService) {
      placesService.getDetails({ placeId: selected.place_id }, (place) => {
        if (place && place.formatted_address && onPlaceSelected) {
          onPlaceSelected(place);
        }
      });
    }
  };

  return (
    <Autocomplete
      fullWidth
      getOptionLabel={(option) => (typeof option === "string" ? option : option.description)}
      options={options}
      autoComplete
      size="small"
      includeInputInList
      filterSelectedOptions
      value={value}
      onChange={(event, newValue) => handleSelect(newValue)}
      onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
      noOptionsText="Start typing to search for addresses..."
      renderInput={(params) => <TextField {...params} label={label} variant="outlined" />}
      renderOption={(props, option) => {

        return (
          <li {...props}>
            <Grid container alignItems="center">
              <Grid item sx={{ display: "flex", width: 44 }}>
          <LocationOnIcon sx={{ color: "text.secondary" }} />
              </Grid>
              <Grid item sx={{ width: "calc(100% - 44px)", display: "flex", alignItems: "center" }}>
          <Typography variant="body2" sx={{ fontWeight: "bold", mr: 1 }}>
            {option.structured_formatting.main_text}
          </Typography>
          {option.structured_formatting.secondary_text && (
            <Typography variant="body2" color="text.secondary">
              {option.structured_formatting.secondary_text}
            </Typography>
          )}
              </Grid>
            </Grid>
          </li>
        );
      }}
    />
  );
}
